module.exports = __webpack_public_path__ + "static/img/logo-oficina-virtual.e8f2585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-oficina-virtual.png
// module id = aO0j
// module chunks = 9